import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCursorClick16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCursorClick16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.569 6.731a3.785 3.785 0 1 0-3.824 3.838l.295.994q-.127.006-.255.006a4.785 4.785 0 1 1 4.778-4.541zM7.106 8.238a1.49 1.49 0 1 1 1.132-1.132l5.26 1.503a.5.5 0 0 1 .06.94l-2.31.991 2.467 2.468a.5.5 0 0 1-.707.707l-2.468-2.468-.99 2.311a.5.5 0 0 1-.94-.06zm3.08 1.67 1.686-.723L8.11 8.11l1.075 3.762.722-1.687.006-.012.004-.01.074-.172.173-.074z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCursorClick16);
